
import { computed, defineComponent, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { ElMessageBox } from 'element-plus'
import { CaretBottom } from '@element-plus/icons-vue'
import localCache from '@/utils/cache'
import Breadcrumb from '@/components/Breadcrumb/index.vue'
import TopNav from '@/components/TopNav/index.vue'
import Hamburger from '@/components/Hamburger/index.vue'

export default defineComponent({
  components: {
    Breadcrumb,
    TopNav,
    Hamburger,
    CaretBottom
  },
  setup() {
    const store = useStore()
    const router = useRouter()
    
    const sidebar = computed(() => store.state.app.sidebar)
    const avatar = computed(() => store.getters.avatar)
    const device = computed(() => store.state.app.device)
    
    const setting = computed({
      get: () => store.state.settings.showSettings,
      set: (val) => {
        store.dispatch('settings/changeSetting', {
          key: 'showSettings',
          value: val
        })
      }
    })
    
    const topNav = computed(() => store.state.settings.topNav)
    
    const toggleSideBar = () => {
      store.dispatch('app/toggleSideBar')
    }
    
    const logout = async () => {
      try {
        await ElMessageBox.confirm('确定注销并退出系统吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await store.dispatch('user/LogOut')
        //localCache.clearCache()
        location.href = '/login'
      } catch (error) {
        // 取消操作
      }
    }
    
    return {
      sidebar,
      avatar,
      device,
      setting,
      topNav,
      toggleSideBar,
      logout
    }
  }
})
